(ns frontend.view.modals.folder-management-modal.sub
  (:require
   [clojure.set :as set]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::temp-list
 (fn [db]
   (get db ::temp-list)))

(rf/reg-sub
 ::removed-folders
 (fn [db]
   (get db ::removed-folders)))

(rf/reg-sub
 ::original-list
 (fn [db]
   (get db ::original-list)))

(rf/reg-sub
 ::changes?
 :<-
 [::temp-list]
 :<-
 [::original-list]
 (fn [[temp-list original-list] _]
   (->> temp-list
        (remove (fn [{:keys [original-name folder-name status]}]
                  (and (= original-name folder-name)
                       (= status :ok))))
        (not-empty))))

(rf/reg-sub
 ::processing?
 (fn [db]
   (get db ::processing?)))

(rf/reg-sub
 ::target-entity
 (fn [db]
   (get db ::target-entity)))
